import axios from 'axios'
import mocks from './associatedContacts.mock'

export const getAssociatedContactsUrl = (contact, product = 'recording') =>
  contact.isRootRecording
    ? `/api/rest/${product}/associatedcontact/${contact.assocCallId}?expand=metadata&expand=eventCalculations`
    : `/api/rest/${product}/associatedcontact/${contact.id}?useContactId=true&expand=metadata&expand=eventCalculations`

export default {
  async getAssociatedContacts(contact) {
    try {
      const response = await axios.get(getAssociatedContactsUrl(contact))
      return response.data
    } catch (error) {
      throw new Error(error.response.data.errorMessage)
    }
  },
}

export const mock = {
  getAssociatedContacts(contact) {
    return contact.isRootRecording ? mocks.rootRecordingAssociatedContacts : mocks.associatedContacts
  },
}
